import React, { useState } from 'react'
 
 
import FieldActivityTaskList from './FieldActivityTaskList';
import FieldActivityTaskForm from './FieldActivityTaskForm';

const FieldActivityTask= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <FieldActivityTaskForm addForm={setFromIsShown} update={upData} />
        ) : (
          <FieldActivityTaskList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default FieldActivityTask